<template>
  <div v-loading-pld="is_loading" class="Campaigns font-normal p-0" l-tabs="true" l-title="false">
    <div class="Page__bar flex flex-wrap items-center dynamic-height px-3 mb-0 dynamic-width-main">
      <!-- Page title -->
      <div class="Page__title dynamic-width-left">Social Boost Campaigns</div>

      <!-- Tabs -->
      <ElTabs :value="activeTab" class="dynamic-width-center items-end">
        <ElTabPane name="all" lazy>
          <RouterLink slot="label" :to="{ name: 'all' }" class="el-tabs__link"> All </RouterLink>
        </ElTabPane>

        <ElTabPane name="new" lazy>
          <RouterLink slot="label" :to="{ name: 'campaigns-new' }" class="el-tabs__link"> New </RouterLink>
        </ElTabPane>

        <ElTabPane name="in-review" lazy>
          <RouterLink slot="label" :to="{ name: 'campaigns-in-review' }" class="el-tabs__link"> In Review </RouterLink>
        </ElTabPane>

        <ElTabPane name="in-progress" lazy>
          <RouterLink slot="label" :to="{ name: 'campaigns-in-progress' }" class="el-tabs__link"> In Progress </RouterLink>
        </ElTabPane>

        <ElTabPane name="ready-to-launch'" lazy>
          <RouterLink slot="label" :to="{ name: 'campaigns-ready-to-launch' }" class="el-tabs__link"> Ready to Launch </RouterLink>
        </ElTabPane>

        <ElTabPane name="active" lazy>
          <RouterLink slot="label" :to="{ name: 'campaigns-campaign-active' }" class="el-tabs__link"> Active </RouterLink>
        </ElTabPane>
        <ElTabPane name="completed" lazy>
          <RouterLink slot="label" :to="{ name: 'social-boost-completed' }" class="el-tabs__link"> Completed </RouterLink>
        </ElTabPane>
      </ElTabs>

      <div class="flex gap-1 dynamic-width-right custom-responsive">
        <div class="Page__bar-search">
          <ElInput v-model="search" clearable :placeholder="$t('campaign.index.search')" @change="searchAction">
            <ElButton slot="prepend" icon="el-icon-search" />
          </ElInput>
        </div>
        <ElButton
          v-if="($canAccess(['agency', 'agency-employee', 'employee', 'brand-employee']) || $isTopBrandAdmin() || $is_PM) && !$is_GD"
          type="primary"
          @click="createCampaign"
        >
          <i class="el-icon-plus el-icon-left"></i> {{ $t('campaign.index.new_campaign') }}
        </ElButton>
      </div>
    </div>

    <RouterView class="Campaigns--child Loading__target overflow-auto p-0" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CampaignType from '@/components/social-products/social-boost/modal/CampaignType'

export default {
  name: 'SocialBoostIndex',
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters('app', ['is_loading']),
    activeTab() {
      return this.$route.meta.tab
    },
  },
  mounted() {
    this.search = this.$route.query.search
  },
  watch: {
    '$route.query': {
      handler(value) {
        // this.$store.dispatch('socialBoostCampaign/getCampaigns', value)
      },
      deep: true,
    },
  },
  methods: {
    createCampaign() {
      this.$Modal.init(
        {
          propsData: {
            component: CampaignType,
            meta: { title: 'Create Campaign' },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
    searchAction(search) {
      if (search.length < 3 && search.length !== 0) {
        this.$message({
          showClose: true,
          message: 'At least 3 characters are required to search!',
          type: 'warning',
        })
        return
      }
      if (search !== this.$route.query.search) {
        const query = { ...this.$route.query }
        // Delete page
        delete query.page

        // Assign new search to route
        Object.assign(query, { search: this.search })
        // Delete empty searches
        if (query.search === '') {
          delete query.search
        }

        this.$router.push({ query: query })
        this.$store.dispatch('socialBoostCampaign/getCampaigns', { ...query })
      }
    },
  },
}
</script>

<style>
@media (max-width: 1500px) {
  .custom-responsive {
    flex: 1 1 auto;
    margin-bottom: 10px;
  }
}
</style>
